export const MAX_LEVEL_NUMBER = 9;
export const MAX_SUB_LEVEL_NUMBER = 10;

export const CARDS_PER_LEVEL = [
  // Tier 1: 1,900 total
  [0, 40, 80, 120, 160, 200, 300, 400, 600],
  // Tier 2: 10,400 total
  [0, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000],
  // Tier 3: 58,400 total
  [0, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500],
  // Elite 1: 24,000 total
  [0, 3000, 3000, 3000, 3000, 3000, 3000, 3000, 3000],
  // Elite 2: 24,000 total
  [0, 3000, 3000, 3000, 3000, 3000, 3000, 3000, 3000],
];

export const COINS_PER_LEVEL = {
  drone: [
    // Tier 1
    [
      [2, 6, 10, 18, 28, 40, 56, 76, 100, 128],
      [160, 198, 238, 286, 336, 390, 452, 518, 588, 666],
      [748, 836, 930, 1030, 1136, 1248, 1366, 1490, 1620, 1758],
      [1900, 2050, 2208, 2372, 2542, 2720, 2906, 3096, 3296, 3502],
      [3716, 3936, 4166, 4400, 4646, 4896, 5156, 5422, 5698, 5980],
      [6270, 6570, 6878, 7192, 7516, 7848, 8188, 8538, 8896, 9260],
      [9632, 10020, 10410, 10812, 11222, 11640, 12068, 12506, 12950, 13406],
      [13870, 14342, 14826, 15318, 15820, 16330, 16850, 17380, 17920, 18470],
      [19028, 19598, 20176, 20762, 21360, 21970, 22588, 23216, 23852, 24502],
    ],
    // Tier 2
    [
      [25160, 25828, 26508, 27198, 27896, 28606, 29328, 30058, 30798, 31550],
      [32312, 33086, 33870, 34666, 35470, 36268, 37112, 37950, 38800, 29660],
      [40530, 41412, 42306, 43208, 44122, 45050, 45988, 46938, 47898, 48868],
      [49852, 50846, 51852, 52870, 53898, 54940, 55990, 57056, 58130, 59218],
      [60318, 61428, 62550, 63686, 64832, 65990, 67160, 68342, 69538, 70746],
      [71962, 73196, 74438, 75692, 76960, 78240, 79532, 80838, 82156, 83486],
      [84826, 86180, 87548, 88928, 90320, 91722, 93140, 94570, 96016, 97470],
      [
        98938, 100420, 101912, 103420, 104940, 106472, 108020, 109578, 111150,
        112736,
      ],
      [
        114332, 115946, 117568, 119206, 120858, 122520, 124198, 125888, 127592,
        129310,
      ],
    ],
    // Tier 3
    [
      [
        131040, 132786, 134542, 136316, 138100, 139898, 141710, 143536, 145372,
        147228,
      ],
      [
        149092, 150972, 152868, 154776, 156698, 158632, 160582, 162546, 164522,
        166512,
      ],
      [
        168518, 170538, 172570, 174618, 176680, 178756, 180846, 182948, 185066,
        187198,
      ],
      [
        189346, 191506, 193680, 195870, 198076, 200292, 202526, 204772, 207032,
        209310,
      ],
      [
        211600, 213906, 216226, 218560, 220910, 223272, 225650, 228046, 230452,
        232876,
      ],
      [
        235312, 237766, 240230, 242712, 245210, 247720, 250248, 252790, 255346,
        257918,
      ],
      [
        260506, 263106, 265722, 268356, 271022, 273666, 276342, 279036, 281742,
        284466,
      ],
      [
        287206, 289958, 292728, 295512, 298312, 301128, 303958, 306806, 309666,
        312542,
      ],
      [
        315436, 318346, 321268, 324208, 327162, 330132, 333120, 336122, 339140,
        342172,
      ],
    ],
    // Elite 1
    [
      [
        345223, 348288, 351370, 354465, 357578, 360708, 363853, 367013, 370188,
        373380,
      ],
      [
        376590, 379815, 383055, 386310, 389583, 392873, 396178, 399498, 402835,
        406188,
      ],
      [
        409558, 412945, 416348, 419765, 423200, 426655, 430118, 433603, 437103,
        440620,
      ],
      [
        444153, 447703, 451268, 454850, 458450, 462065, 465698, 469348, 473013,
        476695,
      ],
      [
        480393, 484110, 487843, 491590, 495355, 499138, 502938, 506755, 510588,
        514438,
      ],
      [
        518303, 522188, 526088, 530005, 533940, 537890, 541860, 545845, 549848,
        553868,
      ],
      [
        557903, 561958, 566028, 570118, 574223, 578345, 582483, 586640, 593150,
        595005,
      ],
      [
        599215, 603440, 607685, 611945, 616223, 620518, 624830, 629160, 633510,
        637875,
      ],
      [
        642258, 646658, 651075, 655510, 659963, 664433, 668923, 673428, 677950,
        682493,
      ],
    ],
    // Elite 2
    [
      [
        500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000,
        500000,
      ],
      [
        500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000,
        500000,
      ],
      [
        500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000,
        500000,
      ],
      [
        500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000,
        500000,
      ],
      [
        500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000,
        500000,
      ],
      [
        500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000,
        500000,
      ],
      [
        500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000,
        500000,
      ],
      [
        500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000,
        500000,
      ],
      [
        500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000, 500000,
        500000,
      ],
    ],
  ],
  ship: [
    // Tier 1
    [
      [5, 10, 20, 35, 55, 80, 110, 150, 200, 255],
      [320, 395, 475, 570, 670, 780, 905, 1035, 1175, 1330],
      [1495, 1670, 1860, 2060, 2270, 2495, 2730, 2980, 3240, 3515],
      [3800, 4100, 4415, 4745, 5085, 5440, 5810, 6190, 6590, 7005],
      [7430, 7870, 8330, 8800, 9290, 9790, 10310, 10845, 11395, 11960],
      [12540, 13140, 13755, 14385, 15030, 15695, 16375, 17075, 17790, 18520],
      [19270, 20040, 20820, 21625, 22445, 23280, 24135, 25010, 25900, 26810],
      [27740, 28685, 29650, 30635, 31640, 32330, 33700, 34760, 35840, 36940],
      [38055, 39195, 40350, 41525, 42720, 43940, 45175, 46430, 47705, 49055],
    ],
    // Tier 2
    [
      [50320, 51655, 53015, 54395, 55790, 57210, 58655, 60115, 61595, 63100],
      [64625, 66170, 67740, 63330, 70340, 72570, 74225, 75900, 77600, 79320],
      [81060, 82825, 84610, 86415, 88245, 90095, 91975, 93875, 95795, 97735],
      [
        93705, 101630, 103705, 105740, 107735, 103880, 111980, 114110, 116260,
        118435,
      ],
      [
        120635, 122855, 125100, 127370, 123655, 131980, 134320, 136685, 133075,
        141490,
      ],
      [
        143925, 146330, 148875, 151385, 153920, 156480, 153065, 161675, 164310,
        166970,
      ],
      [
        169650, 172360, 175095, 177855, 180640, 183445, 186280, 183140, 192030,
        194940,
      ],
      [
        197875, 200840, 203825, 206840, 209880, 212945, 216040, 213155, 222300,
        225470,
      ],
      [
        228665, 231890, 235135, 238410, 241715, 245040, 248395, 251775, 255185,
        258620,
      ],
    ],
    // Tier 3
    [
      [
        262080, 265570, 269085, 272630, 276200, 279795, 283420, 287070, 290745,
        294455,
      ],
      [
        298185, 301345, 305735, 309550, 313395, 317625, 321165, 325090, 329045,
        333025,
      ],
      [
        337035, 341075, 345140, 349235, 353360, 357510, 361690, 365895, 370130,
        374395,
      ],
      [
        378690, 383010, 387360, 391740, 396150, 400585, 405050, 409545, 414065,
        418620,
      ],
      [
        423200, 427810, 432450, 437120, 441820, 446545, 451300, 456090, 460905,
        465750,
      ],
      [
        470625, 475530, 480460, 485425, 490420, 495440, 500435, 505580, 510630,
        515835,
      ],
      [
        521010, 526210, 531445, 536710, 542005, 547330, 552685, 558070, 563485,
        568930,
      ],
      [
        574410, 579915, 585455, 591025, 596625, 602255, 607315, 613610, 619330,
        625085,
      ],
      [
        630870, 636690, 642535, 648415, 654325, 660265, 666240, 672245, 678280,
        684345,
      ],
    ],
    // Elite 1
    [
      [
        690445, 696575, 702740, 708930, 715155, 721415, 727705, 734025, 740375,
        746760,
      ],
      [
        753180, 759630, 766110, 772620, 779165, 785745, 792355, 798995, 805670,
        812375,
      ],
      [
        819115, 825890, 832695, 839530, 846400, 853310, 860235, 867205, 874205,
        881240,
      ],
      [
        888305, 895405, 902535, 909700, 916900, 924130, 931395, 938695, 946025,
        953390,
      ],
      [
        960785, 968220, 975685, 983180, 990710, 998275, 1005875, 1013510,
        1021175, 1028875,
      ],
      [
        1036605, 1044375, 1052175, 1060010, 1067880, 1075780, 1083720, 1091690,
        1099695, 1107735,
      ],
      [
        1115805, 1123915, 1132055, 1140235, 1148445, 1156690, 1164965, 1173280,
        1186300, 1190010,
      ],
      [
        1198430, 1206880, 1215370, 1223890, 1232445, 1241035, 1249660, 1258320,
        1267020, 1275750,
      ],
      [
        1284515, 1293315, 1302150, 1311020, 1319925, 1328865, 1337845, 1346855,
        1355900, 1364985,
      ],
    ],
    // Elite 2
    [
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
    ],
  ],
  stone: [
    // Tier 1
    [
      [5, 10, 20, 35, 55, 80, 110, 150, 200, 255],
      [320, 395, 475, 570, 670, 780, 905, 1035, 1175, 1330],
      [1495, 1670, 1860, 2060, 2270, 2495, 2730, 2980, 3240, 3515],
      [3800, 4100, 4415, 4745, 5085, 5440, 5810, 6190, 6590, 7005],
      [7430, 7870, 8330, 8800, 9290, 9790, 10310, 10845, 11395, 11960],
      [12540, 13140, 13755, 14385, 15030, 15695, 16375, 17075, 17790, 18520],
      [19270, 20040, 20820, 21625, 22445, 23280, 24135, 25010, 25900, 26810],
      [27740, 28685, 29650, 30635, 31640, 32330, 33700, 34760, 35840, 36940],
      [38055, 39195, 40350, 41525, 42720, 43940, 45175, 46430, 47705, 49055],
    ],
    // Tier 2
    [
      [50320, 51655, 53015, 54395, 55790, 57210, 58655, 60115, 61595, 63100],
      [64625, 66170, 67740, 63330, 70340, 72570, 74225, 75900, 77600, 79320],
      [81060, 82825, 84610, 86415, 88245, 90095, 91975, 93875, 95795, 97735],
      [
        93705, 101630, 103705, 105740, 107735, 103880, 111980, 114110, 116260,
        118435,
      ],
      [
        120635, 122855, 125100, 127370, 123655, 131980, 134320, 136685, 133075,
        141490,
      ],
      [
        143925, 146330, 148875, 151385, 153920, 156480, 153065, 161675, 164310,
        166970,
      ],
      [
        169650, 172360, 175095, 177855, 180640, 183445, 186280, 183140, 192030,
        194940,
      ],
      [
        197875, 200840, 203825, 206840, 209880, 212945, 216040, 213155, 222300,
        225470,
      ],
      [
        228665, 231890, 235135, 238410, 241715, 245040, 248395, 251775, 255185,
        258620,
      ],
    ],
    // Tier 3
    [
      [
        262080, 265570, 269085, 272630, 276200, 279795, 283420, 287070, 290745,
        294455,
      ],
      [
        298185, 301345, 305735, 309550, 313395, 317625, 321165, 325090, 329045,
        333025,
      ],
      [
        337035, 341075, 345140, 349235, 353360, 357510, 361690, 365895, 370130,
        374395,
      ],
      [
        378690, 383010, 387360, 391740, 396150, 400585, 405050, 409545, 414065,
        418620,
      ],
      [
        423200, 427810, 432450, 437120, 441820, 446545, 451300, 456090, 460905,
        465750,
      ],
      [
        470625, 475530, 480460, 485425, 490420, 495440, 500435, 505580, 510630,
        515835,
      ],
      [
        521010, 526210, 531445, 536710, 542005, 547330, 552685, 558070, 563485,
        568930,
      ],
      [
        574410, 579915, 585455, 591025, 596625, 602255, 607315, 613610, 619330,
        625085,
      ],
      [
        630870, 636690, 642535, 648415, 654325, 660265, 666240, 672245, 678280,
        684345,
      ],
    ],
    // Elite 1
    [
      [
        690445, 696575, 702740, 708930, 715155, 721415, 727705, 734025, 740375,
        746760,
      ],
      [
        753180, 759630, 766110, 772620, 779165, 785745, 792355, 798995, 805670,
        812375,
      ],
      [
        819115, 825890, 832695, 839530, 846400, 853310, 860235, 867205, 874205,
        881240,
      ],
      [
        888305, 895405, 902535, 909700, 916900, 924130, 931395, 938695, 946025,
        953390,
      ],
      [
        960785, 968220, 975685, 983180, 990710, 998275, 1005875, 1013510,
        1021175, 1028875,
      ],
      [
        1036605, 1044375, 1052175, 1060010, 1067880, 1075780, 1083720, 1091690,
        1099695, 1107735,
      ],
      [
        1115805, 1123915, 1132055, 1140235, 1148445, 1156690, 1164965, 1173280,
        1186300, 1190010,
      ],
      [
        1198430, 1206880, 1215370, 1223890, 1232445, 1241035, 1249660, 1258320,
        1267020, 1275750,
      ],
      [
        1284515, 1293315, 1302150, 1311020, 1319925, 1328865, 1337845, 1346855,
        1355900, 1364985,
      ],
    ],
    // Elite 2
    [
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
      [
        1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000, 1000000,
        1000000, 1000000,
      ],
    ],
  ],
};

export const GEMS_PER_LEVEL = {
  drone: [
    // Tier 1
    [0, 10, 20, 30, 40, 50, 60, 70, 80],
    // Tier 2
    [100, 100, 150, 200, 250, 300, 350, 400, 450],
    // Tier 3
    [500, 500, 750, 1000, 1250, 1500, 1750, 2000, 2250],
    // Elite 1
    [1250, 1250, 1250, 1250, 1250, 1250, 1250, 1250, 1250],
    // Elite 2
    [1250, 1250, 1250, 1250, 1250, 1250, 1250, 1250, 1250],
  ],
  ship: [
    // Tier 1
    [0, 20, 40, 60, 80, 100, 120, 140, 160],
    // Tier 2
    [200, 200, 300, 400, 500, 600, 700, 800, 900],
    // Tier 3
    [1000, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500],
    // Elite 1
    [2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500],
    // Elite 2
    [2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500],
  ],
  stone: [
    // Tier 1
    [0, 20, 40, 60, 80, 100, 120, 140, 160],
    // Tier 2
    [200, 200, 300, 400, 500, 600, 700, 800, 900],
    // Tier 3
    [1000, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500],
    // Elite 1
    [2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500],
    // Elite 2
    [2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500, 2500],
  ],
};

export const GEMS_TO_MERGE = {
  drone: [
    // Tier 1
    0,
    // Tier 1 to 2
    250,
    // Tier 2 to 3
    500,
    // Tier 3 to Elite 1
    2500,
    // Elite 1 to Elite 2
    2500,
  ],
  ship: [
    // Tier 1
    0,
    // Tier 1 to 2
    500,
    // Tier 2 to 3
    1000,
    // Tier 3 to Elite 1
    5000,
    // Elite 1 to Elite 2
    5000,
  ],
  stone: [
    // Tier 1
    0,
    // Tier 1 to 2
    500,
    // Tier 2 to 3
    1000,
    // Tier 3 to Elite 1
    5000,
    // Elite 1 to Elite 2
    5000,
  ],
};
